"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shimmer = void 0;
var Utilities_1 = require("../../Utilities");
var Shimmer_styles_1 = require("./Shimmer.styles");
var Shimmer_base_1 = require("./Shimmer.base");
exports.Shimmer = (0, Utilities_1.styled)(Shimmer_base_1.ShimmerBase, Shimmer_styles_1.getStyles, undefined, {
    scope: 'Shimmer',
});
//# sourceMappingURL=Shimmer.js.map